import { sortBy } from "@s-libs/micro-dash";

import { License } from "@/types/models/License.interface";
import type { User } from "@/types/models/User.interface";

interface UserProp extends Pick<User, "licenses"> {}

interface LicenseProp {
  product?: License["product"];
  onlyActive?: boolean;
}

const getAllLicenses = (
  user: UserProp,
  { product, onlyActive = true }: LicenseProp = {},
) => {
  if (!user) return;
  const licenses = user?.licenses || [];
  const filteredLicenses = licenses.filter((license) => {
    return (
      (license.product === product || !product) &&
      (!onlyActive || license.is_active)
    );
  });
  // This logic mirrors the logic in the Django License model.
  const sortedLicenses = sortBy(filteredLicenses, [
    (license) => license.is_active,
    (license) => license.is_trial,
    (license) => new Date(license.date_ends),
  ]);
  return sortedLicenses;
};

export default getAllLicenses;
